import Vue from '../vue/common/vue-common';
import HistoryInPrints from '../vue/components/historia-em-estampas/HistoryInPrints.vue';
import VuePrlx from 'vue-prlx';

cr$.ready(function () {
    Vue.use(VuePrlx);
    requestIdleCallback(() => new Vue(HistoryInPrints));
});
